module.exports = __webpack_public_path__ + "img/6_14.fbb6a460.png";